// 兄弟之间传值
import Vue from 'Vue'
const Bus = new Vue();
export default Bus;


// WEBPACK FOOTER //
// ./src/utils/bus.js